module.exports = __webpack_public_path__ + "overview-a5b6df21/kununuLogo-95638cc24594e9ceb45321d65d915dd3.svg";